export default {
  title: "Human",
  content: [
    "Mace Specialization removed.",
    "The Human Spirit now allows 5% of your Mana regeneration to continue while casting.",
  ],
};
